import { render, staticRenderFns } from "./ModalChangeEmail.vue?vue&type=template&id=1252ffeb&scoped=true&"
import script from "./ModalChangeEmail.vue?vue&type=script&lang=js&"
export * from "./ModalChangeEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1252ffeb",
  null
  
)

export default component.exports